import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row items-center q-pb-md" }
const _hoisted_2 = { class: "col-2 text-subtitle1 text-fun-label-and-icon" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row items-center q-pt-md q-pb-sm" }
const _hoisted_5 = { class: "col-2 text-subtitle1 text-fun-label-and-icon" }
const _hoisted_6 = { class: "row items-center q-pb-md" }
const _hoisted_7 = { class: "col-2 text-subtitle1 text-fun-label-and-icon" }
const _hoisted_8 = { class: "row justify-between" }
const _hoisted_9 = { class: "row text-body1" }
const _hoisted_10 = { class: "col q-pr-md" }
const _hoisted_11 = { class: "row items-center q-pb-sm" }
const _hoisted_12 = { class: "row items-center q-pb-sm" }
const _hoisted_13 = { class: "col q-pl-md" }
const _hoisted_14 = { class: "row items-center q-pb-sm" }
const _hoisted_15 = { class: "row items-center q-pb-sm" }

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxSeparator from "src/components/special/SfxSeparator.vue"
import SfxToggleSettings from "src/components/toggle/SfxToggleSettings.vue"
import SfxSelect from "src/components/select/SfxSelect.vue"
import SfxBtnLink from "src/components/button/SfxBtnLink.vue"
import router from "src/router"
import { PerformedWorkPageFilters, useFilterStore } from "src/stores/filterStore"
import { ENTITY_TYPE, PART_OF_WORK_ORDER, WORK_TYPE } from "src/util/enums/filters"
import { NamedManagerPath } from "src/util/enums/namedPaths"
import { getItemClassListData, getWorkDomainWorkspaceListData } from "src/util/functions/entityData"
import { showNotImplementedNotification } from "src/util/functions/notifications"
import { ItemClass } from "src/util/types/dataModels/itemClass"
import { WorkDomainWorkspace } from "src/util/types/dataModels/workDomain"
import SfxFilterSystemLink from "src/components/filter/SfxFilterSystemLink.vue"
import { onBeforeMount, reactive, ref } from "vue"
import { useI18n } from "vue-i18n"
import { PERFORMED_WORK_FILTER_STATE } from "src/util/constants/filters"

//region Props and Emits
//endregion

//region Variables


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogFilterPerformedWork',
  setup(__props) {

const { t } = useI18n()
const filterStore = useFilterStore()
const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const workDomainOptions = ref<WorkDomainWorkspace[]>([])
const itemClassOptions = ref<ItemClass[]>([])
const areaAttributeSetOptions = ref([])

const performedWorkPageFilters = reactive<PerformedWorkPageFilters>({
  ...filterStore.performedWorkPageFilters,
})

//endregion

//region Lifecycle

onBeforeMount(async () => {
  const workDomains = await getWorkDomainWorkspaceListData()
  workDomainOptions.value = workDomains.map((workDomain) => workDomain.toMutableJSON())
  const itemClasses = await getItemClassListData()
  itemClassOptions.value = itemClasses.map((itemClass) => itemClass.toMutableJSON())
})

//endregion

//region Functions

function handleSystemLinkClose() {
  performedWorkPageFilters.systemLink = undefined
  filterStore.performedWorkPageFilters.systemLink = undefined
}

function saveFilters() {
  filterStore.performedWorkPageFilters = performedWorkPageFilters

  // Set the flag value
  filterStore.performedWorkPageFilters.hasFilters = true

  onDialogOK()

  router.replace({
    name: NamedManagerPath.SELECT_PERFORMED_WORK,
    query: {
      filters: JSON.stringify(filterStore.performedWorkPageFilters),
    },
  })
}

function selectAll() {
  performedWorkPageFilters.state = PERFORMED_WORK_FILTER_STATE
}

function selectNone() {
  performedWorkPageFilters.state = []
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "sfx-dialog-filter"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 q-pb-lg" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.title_filter_performed_work")), 1)
            ]),
            _: 1
          }),
          (performedWorkPageFilters.systemLink)
            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(SfxFilterSystemLink, {
                    "system-link": performedWorkPageFilters.systemLink,
                    onRemove: _cache[0] || (_cache[0] = ($event: any) => (handleSystemLinkClose()))
                  }, null, 8, ["system-link"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)("sfxDialogFilter.work_domain")), 1),
                _createVNode(SfxSelect, {
                  class: "col-10",
                  placeholder: _unref(t)('sfxDialogFilter.place_holder_work_domain'),
                  modelValue: performedWorkPageFilters.workDomain,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((performedWorkPageFilters.workDomain) = $event)),
                  options: workDomainOptions.value,
                  "option-label": (opt) => opt.designation,
                  "option-value": (opt) => opt.id,
                  loading: workDomainOptions.value?.length === 0,
                  "emit-value": "",
                  "map-options": "",
                  "use-chips": "",
                  multiple: ""
                }, null, 8, ["placeholder", "modelValue", "options", "option-label", "option-value", "loading"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(SfxToggleSettings, {
                  class: "col-4",
                  html: "",
                  trinary: "",
                  modelValue: performedWorkPageFilters.entityType,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((performedWorkPageFilters.entityType) = $event)),
                  description: _unref(t)('sfxDialogFilter.entity_type'),
                  "true-value": _unref(ENTITY_TYPE).ITEM,
                  "true-label": _unref(t)('sfxDialogFilter.item'),
                  "false-value": _unref(ENTITY_TYPE).AREA,
                  "false-label": _unref(t)('sfxDialogFilter.area'),
                  "indeterminate-value": _unref(ENTITY_TYPE).EITHER,
                  "indeterminate-label": _unref(t)('sfxDialogFilter.either'),
                  onClick: _unref(showNotImplementedNotification),
                  disable: ""
                }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label", "indeterminate-value", "indeterminate-label", "onClick"]),
                _createVNode(SfxToggleSettings, {
                  class: "col-4",
                  html: "",
                  trinary: "",
                  modelValue: performedWorkPageFilters.workType,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((performedWorkPageFilters.workType) = $event)),
                  description: _unref(t)('sfxDialogFilter.work_type'),
                  "true-value": _unref(WORK_TYPE).REGULAR,
                  "true-label": _unref(t)('sfxDialogFilter.regular'),
                  "false-value": _unref(WORK_TYPE).CORRECTIVE,
                  "false-label": _unref(t)('sfxDialogFilter.corrective'),
                  "indeterminate-value": _unref(WORK_TYPE).EITHER,
                  "indeterminate-label": _unref(t)('sfxDialogFilter.either')
                }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label", "indeterminate-value", "indeterminate-label"]),
                _createVNode(SfxToggleSettings, {
                  class: "col-4",
                  html: "",
                  trinary: "",
                  modelValue: performedWorkPageFilters.partOfWorkOrder,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((performedWorkPageFilters.partOfWorkOrder) = $event)),
                  description: _unref(t)('sfxDialogFilter.part_of_work_order'),
                  "true-value": _unref(PART_OF_WORK_ORDER).YES,
                  "true-label": _unref(t)('sfxDialogFilter.yes'),
                  "false-value": _unref(PART_OF_WORK_ORDER).NO,
                  "false-label": _unref(t)('sfxDialogFilter.no'),
                  "indeterminate-value": _unref(PART_OF_WORK_ORDER).EITHER,
                  "indeterminate-label": _unref(t)('sfxDialogFilter.either')
                }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label", "indeterminate-value", "indeterminate-label"])
              ]),
              _createVNode(SfxSeparator, { class: "sfx-separator-text" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.entity_grouping")), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("sfxDialogFilter.item_class")), 1),
                _createVNode(SfxSelect, {
                  class: "col-10",
                  placeholder: _unref(t)('sfxDialogFilter.place_holder_item_class'),
                  modelValue: performedWorkPageFilters.itemClass,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((performedWorkPageFilters.itemClass) = $event)),
                  options: itemClassOptions.value,
                  "option-label": (opt) => opt.designation,
                  "option-value": (opt) => opt.id,
                  loading: itemClassOptions.value?.length === 0,
                  "emit-value": "",
                  "map-options": "",
                  "use-chips": "",
                  multiple: ""
                }, null, 8, ["placeholder", "modelValue", "options", "option-label", "option-value", "loading"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)("sfxDialogFilter.area_attribute_set")), 1),
                _createVNode(SfxSelect, {
                  class: "col-10",
                  placeholder: _unref(t)('sfxDialogFilter.place_holder_area_attribute_set'),
                  modelValue: performedWorkPageFilters.areaAttributeSet,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((performedWorkPageFilters.areaAttributeSet) = $event)),
                  options: areaAttributeSetOptions.value,
                  "option-label": (opt) => opt.designation,
                  "option-value": (opt) => opt.id,
                  "emit-value": "",
                  "map-options": "",
                  "use-chips": "",
                  multiple: "",
                  disable: ""
                }, null, 8, ["placeholder", "modelValue", "options", "option-label", "option-value"])
              ]),
              _createVNode(SfxSeparator, { class: "sfx-separator-text" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.conclusion")), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(SfxBtnLink, {
                  class: "q-pl-none",
                  label: _unref(t)('sfxButtons.btn_select_none'),
                  onClick: selectNone
                }, null, 8, ["label"]),
                _createVNode(SfxBtnLink, {
                  class: "q-pr-none",
                  label: _unref(t)('sfxButtons.btn_select_all'),
                  onClick: selectAll
                }, null, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.unreviewed")), 1),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_checkbox, {
                      modelValue: performedWorkPageFilters.state,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((performedWorkPageFilters.state) = $event)),
                      val: "unreviewed",
                      size: "48px",
                      color: "secondary",
                      dense: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.accepted")), 1),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_checkbox, {
                      modelValue: performedWorkPageFilters.state,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((performedWorkPageFilters.state) = $event)),
                      val: "accepted",
                      size: "48px",
                      color: "secondary",
                      dense: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.not_applicable")), 1),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_checkbox, {
                      modelValue: performedWorkPageFilters.state,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((performedWorkPageFilters.state) = $event)),
                      val: "not_applicable",
                      size: "48px",
                      color: "secondary",
                      dense: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.rejected")), 1),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_checkbox, {
                      modelValue: performedWorkPageFilters.state,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((performedWorkPageFilters.state) = $event)),
                      val: "rejected",
                      size: "48px",
                      color: "secondary",
                      dense: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "row justify-center q-pa-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                class: "col-4 q-mr-sm",
                onClick: _unref(onDialogCancel),
                label: _unref(t)('sfxButtons.btn_close')
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                class: "col-4",
                onClick: saveFilters,
                label: _unref(t)('sfxButtons.btn_apply_changes')
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})